import { gql } from '@apollo/client';

export const CREATE_SUBJECT_REPORT_DATAS = gql`
  mutation createSubjectReportDatas($inputs: [CreateSubjectReportDataInput!]!) {
    reports: createSubjectReportDatas(inputs: $inputs) {
      id
    }
  }
`;
